import { Injectable } from '@angular/core';
import { SelectableLab } from './carrier/selectable-lab';

@Injectable()
export class Globals {
    selectedLab: SelectableLab;  
}